import { DestinationPageType } from './fields';
import { capitalize } from 'utils/str-utils';

export const getDestinationPageTitle = (destinationPage: DestinationPageType) =>
  capitalize(destinationPage.replace('_', ' ').toLowerCase());
